import Paper, { PaperProps } from "@mui/material/Paper";

export default Paper;
export type { PaperProps };
